module.exports = __webpack_public_path__ + "img/emoji_rainy.372e0204.png";